import { useContext, useEffect, useState } from "react";
import Button from "./Button";
import { MultiContext } from "../Context";
import AccountItem from "./items/AccountItem";
import Input from "./Input";
import NewAccount from "./forms/NewAccount";

export default function Display({ className = "" }) {
  const multiCtx = useContext(MultiContext);

  const [theme, setTheme] = useState(
    localStorage.getItem("lockr-theme") || "light"
  );

  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [url, setUrl] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [notes, setNotes] = useState("");

  const [deleting, setDeleting] = useState(false);
  const [copied, setCopied] = useState(false);
  const [hidePassword, setHidePassword] = useState(true);

  const onChangeName = (e) => setName(e.target.value);
  const onChangeUsername = (e) => setUsername(e.target.value);
  const onChangePassword = (e) => setPassword(e.target.value);
  const onChangeUrl = (e) => setUrl(e.target.value);
  const onChangeThumbnail = (e) => setThumbnail(e.target.value);
  const onChangeNotes = (e) => setNotes(e.target.value);

  const copyPassword = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  useEffect(() => {
    setName(multiCtx.selectedAccount?.name);
    setUsername(multiCtx.selectedAccount?.username);
    setPassword(multiCtx.selectedAccount?.password);
    setUrl(multiCtx.selectedAccount?.url);
    setThumbnail(multiCtx.selectedAccount?.thumbnail);
    setNotes(multiCtx.selectedAccount?.notes);
  }, [multiCtx.selectedAccount]);

  useEffect(() => {
    localStorage.setItem("lockr-theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <div className={className + " body"}>
      <div className="inner">
        <div className="nav-custom">
          <Button
            border={false}
            icon={theme === "light" ? "sun-fill" : "moon-fill"}
            onClick={() => setTheme(theme === "light" ? "dark" : "light")}
            className="text-capitalize"
          />
        </div>

        <div className="flex h-100 mt-3">
          <div className="col-25">
            <Button
              onClick={() => multiCtx.setSelectedAccount(null)}
              active={!multiCtx.selectedAccount}
              text="New"
              icon="plus-lg"
              className="w-100 green"
            />
            <div className="divider my-2"></div>
            {multiCtx.accounts.map((x) => (
              <AccountItem item={x} />
            ))}
          </div>
          <div className="divider"></div>
          <div className="col-75">
            {multiCtx.selectedAccount ? (
              <form
                onSubmit={(e) =>
                  multiCtx.editAccount(
                    e,
                    multiCtx.selectedAccount?.id,
                    name,
                    username,
                    password,
                    url,
                    thumbnail,
                    notes
                  )
                }
                className="">
                <div className="d-flex mb-2">
                  <img
                    src={multiCtx.selectedAccount?.thumbnail}
                    width={75}
                    height={75}
                    className="rounded-lg rounded me-2"
                  />
                  <Input
                    style={{
                      fontSize: "2rem",
                      fontWeight: "bold",
                    }}
                    border={false}
                    className=""
                    value={name}
                    onChange={onChangeName}
                  />
                </div>

                <div className="between my-3">
                  <div>
                    {multiCtx.selectedAccount?.url && (
                      <a
                        className="btn btn-sm border-0"
                        target="_blank"
                        href={multiCtx.selectedAccount?.url}>
                        <i className="bi bi-box-arrow-right"></i>
                      </a>
                    )}
                  </div>
                  <div className="btn-group">
                    {deleting && (
                      <Button
                        className="red"
                        icon="question-lg"
                        onClick={() => {
                          multiCtx.deleteAccount();
                          setDeleting(false);
                        }}
                      />
                    )}

                    <Button
                      className="red"
                      text="Delete"
                      icon="trash2"
                      onClick={() => setDeleting(!deleting)}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="small fw-bold">Username</div>
                  <Input value={username} onChange={onChangeUsername} />
                </div>
                <div className="mb-3">
                  <div className="small fw-bold">Password</div>
                  <div className="input-group">
                    <Input
                      type_={hidePassword ? "password" : "text"}
                      value={password}
                      onChange={onChangePassword}
                    />
                    <Button
                      onClick={() => setHidePassword(!hidePassword)}
                      icon={"eye" + (hidePassword ? "" : "-slash-fill")}
                      border={false}
                    />
                    <Button
                      onClick={() => copyPassword()}
                      icon={copied ? "check-lg" : "copy"}
                      border={false}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="small fw-bold">URL</div>
                  <Input value={url} onChange={onChangeUrl} />
                </div>
                <div className="mb-3">
                  <div className="small fw-bold">Thumbnail URL</div>
                  <Input value={thumbnail} onChange={onChangeThumbnail} />
                </div>
                <div className="mb-3">
                  <div className="small fw-bold">Notes</div>
                  <textarea
                    className="form-control  form-control-sm"
                    autoComplete="off"
                    rows={5}
                    value={notes}
                    onChange={onChangeNotes}></textarea>
                </div>
                <Button
                  className="w-100"
                  type_="submit"
                  text="Edit"
                  icon="pencil"
                />
                <div className="d-flex mt-3"></div>
              </form>
            ) : (
              <div>
                <div className="heading mb-3">New Account</div>
                <NewAccount />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
